<template>
  <div class="confectionModal">
    <h3 class="confectionModal-title">Koperty z etykietami</h3>
    <img class="confectionModal-image img-responsive" alt="envelope example" :src="image">

    <section class="confectionModal-descriptions">
      <p class="mb-0">Aby uświetnić prezent i sprawić, że każdy pracownik poczuje się wyróżniony, możesz zamówić etykietowane koperty z imieniem, nazwiskiem i przekazywaną kwotą.</p>
    </section>

    <section>
      <p class="mb-0">Na etui mogą zostać nadrukowane takie informacje jak imię, nazwisko, przekazana kwota.</p>
      <p>
        <a :href="file" target="_blank" class="text-underline">Pobierz szablon</a>
        , aby uzupełnić dane, które zostaną nadrukowane na kopertach. Plik będziesz mógł załączyć w kroku „DOSTAWA”.
      </p>
    </section>

    <section class="confectionModal-warnings">
      <p>
        UWAGA! Przed wysłaniem sprawdź, czy liczba zamawianych kopert jest zgodna z liczbą rekordów w pliku excel.
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'confectionDefaultModal',
  props: {
    image: {
      type: String,
      required: true,
    },
    file: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
